import React from 'react'

const ProgressBar = ({value, max, theme, width}) => {
  const fillerStyles = {
    height: 3,
    width: `${(value / max) * 100}%`,
    backgroundColor: "#BC2D2D",
    borderRadius: 'inherit',
    textAlign: 'right'
  }

  const fillerStylesDark = {
    height: 5,
    width: `${(value / max) * 100}%`,
    backgroundColor: "#BC2D2D",
    color: "#BC2D2D",
    borderRadius: 'inherit',
    textAlign: 'right'
  }

  const labelStyles = {
    padding: 2,
    color: 'white',
    fontWeight: 'bold'
    
  }
  
  return (
    <div style={theme ==='dark' ? fillerStylesDark : fillerStyles}>
      <div style={theme ==='dark' ? fillerStylesDark : fillerStyles}>
        <span style={labelStyles}></span> 
      </div>
    </div>
  );
}

export default ProgressBar;